import { TextField } from '~/components/form/TextField';

/**
 * A native date or datetime-local input in the shared field frame. The value is the input's own
 * string (`YYYY-MM-DD`, or `YYYY-MM-DDTHH:mm` for `datetime-local`); see `lib/datetime.ts` to convert.
 */
export const DateField = ({
  id,
  testId,
  type = 'date',
  ...rest
}: {
  id: string;
  /** Defaults to `id`. */
  testId?: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'date' | 'datetime-local';
  helperText?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
}) => <TextField id={id} testId={testId ?? id} type={type} {...rest} />;
